import { render, staticRenderFns } from "./ActionNeededExpensesWidget.vue?vue&type=template&id=49e7ec20&scoped=true"
import script from "./ActionNeededExpensesWidget.vue?vue&type=script&lang=ts"
export * from "./ActionNeededExpensesWidget.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49e7ec20",
  null
  
)

export default component.exports